<template>
	<div class="cluster-member-comp">
		<div class="cluster-member-comp-search">
			<input type="text" placeholder="搜索" v-model="keywords">
		</div>
		<div class="cluster-member-comp-box">
			<div class="cluster-member-comp-list">
				<div class="cluster-member-comp-item" v-for="member in memberList" @click="mClick(member)">
					<img :src="member.friends_photo" alt="">
					<p>{{member.friends_wx_name}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {webGetMemberByClusterId} from '../network/web/cluster-member.js'
	
	export default{
		name:'ClusterMember',
		props:{
			 chatId:{
				default:0
			 },
			 cwxid:{
				default:''
			 },
		},
		data(){
			return {
				orgMemberList: [],
				memberList: [],
				keywords: ''
			}
		},
		methods:{
			// 获取群成员名称
			getMembers(){
				webGetMemberByClusterId(this.chatId,res=>{
					for (let i = 0; i < res.length; i++) {
						let member = res[i]
						member.call_all = 0
						if(this.cwxid !== ''){
							if(member.friends_open_id === this.cwxid){
								if(member.is_owner == 1){
									member.friends_wx_name = '所有人'
									member.friends_photo = '/img/concat-member.png'
									member.friends_open_id = 'notify@all'
									member.call_all = 1
								}else{
									continue
								}	
							}
						}
						this.memberList.push(member)
					}
					this.orgMemberList = JSON.parse(JSON.stringify(this.memberList))
				})
			},
			
			// 群成员点击
			mClick(data){
				this.$emit('cluster-member-call',JSON.parse(JSON.stringify(data)))
			}
		},
		created() {
			this.getMembers()
		},
		watch:{
			keywords(nVal){
				let temp = [];
				for (let i = 0; i < this.orgMemberList.length; i++) {
					let member = this.orgMemberList[i]
					if(member.friends_wx_name.indexOf(nVal) === -1){
						continue
					}
					temp.push(member)
				}
				this.memberList = temp
			}
		}
	}
</script>

<style>
	.cluster-member-comp{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.cluster-member-comp-search{
		height: 30px;
	}
	.cluster-member-comp-search input{
		width: 100%;
		height: 26px;
		line-height: 26px;
		padding: 0 5px;
		box-sizing: border-box;
	}
	.cluster-member-comp-box{
		position: absolute;
		top: 30px;
		bottom: 0;
		left: 0;
		right: 0;
		overflow: auto;
	}
	.cluster-member-comp-list .cluster-member-comp-item{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 5px 0;
		cursor: pointer;
		user-select: none;
		font-size: 12px;
	}
	.cluster-member-comp-item img{
		width: 26px;
		height: 26px;
		border-radius: 4px;
		margin-right: 5px;
	}
	.cluster-member-comp-item p{
		text-overflow: ellipsis;
		white-space: nowrap;
		flex-grow: 1;
		width: 0;
		overflow: hidden;
	}
</style>